

import React from 'react'
import ComingSoon from '../components/comingSoon';
import usePageMeta from '../hooks/usePageMeta';
export default function PrestaShop() {
    usePageMeta('Expert PrestaShop Development Services | Spinnennetz', 'Expert PrestaShop development by Spinnennetz. We build scalable, feature-rich online stores to help your e-commerce business thrive in a competitive market.', '/prestashop', {"@context":"https://schema.org","@type":"Service","name":"PrestaShop Development","provider":{"@type":"Organization","name":"Spinnennetz"}});
    return (
        <>
            <ComingSoon />
        </>
    )
}
